const getGHRData = (state) =>
  __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]?.ghr_genes
    : state && state.variantResult && state.variantResult.ghr_genes;

const getGHRConditionsNumber = (state) => {
  let GHRConditionsNumber;
  const { variantResult } = state;
  if (variantResult && variantResult.ghr_genes) {
    const { conditions_list } = state.variantResult.ghr_genes?.items[0];
    GHRConditionsNumber = conditions_list?.length;
    return GHRConditionsNumber;
  }
  return null;
};

const getGHRTopCondition = (state) => {
  let GHRTopCondition;
  const { variantResult } = state;
  if (variantResult && variantResult.ghr_genes) {
    const { conditions_list: conditionList } =
      state.variantResult.ghr_genes?.items[0];
    GHRTopCondition = conditionList ? conditionList[0].name : null;
    return GHRTopCondition;
  }
  return null;
};

export { getGHRData, getGHRConditionsNumber, getGHRTopCondition };
